import { ValidationError } from './validation/validation.error';
import { ValidatorInput } from './validation/validation-descriptor.entity';
import { ValidationChecks } from './validation/validation-checks.enum';
import { Validator } from './validation/validator.util';
import { UserValidator } from './validation/validation.user';
import { AppConstants } from '../app-constants.service';

export class RegistrationData {

    private readonly checkPassword = (field: ValidatorInput) => {
        UserValidator.validateAndDoubleCheckPw(field, this.passwordConfirm);
    };

    private readonly checkEmail = (field: ValidatorInput) => {
        UserValidator.validateAndDoubleCheckEmail(field, this.emailConfirm);
    };

    loginName = new ValidatorInput(
        'loginName',
        '',
        'Login-Name',
        /^\w+$/,
        null,
        false,
        ValidationChecks.NOT_EMPTY_CHECK
    );

    loginPIN = new ValidatorInput(
        'loginPIN',
        '',
        'Login-PIN',
        /^\w{6}$/,
        'Die Eingabe des Login-PINs ist nicht g&uuml;ltig.',
        true,
        ValidationChecks.NOT_EMPTY_CHECK | ValidationChecks.CUSTOM_REGEX_CHECK
    );

    vorname = new ValidatorInput(
        'vorname',
        '',
        'Vorname',
        /^\w+$/,
        null,
        false,
        ValidationChecks.NOT_EMPTY_CHECK
    );

    nachname = new ValidatorInput(
        'nachname',
        '',
        'Name',
        /^\w+$/,
        null,
        false,
        ValidationChecks.NOT_EMPTY_CHECK
    );

    password = new ValidatorInput(
        'password',
        '',
        'Passwort',
        /^.$/,
        AppConstants.VHV_PASSWORD_ERROR_MSG,
        false,
        ValidationChecks.NOT_EMPTY_CHECK,
        this.checkPassword
    );

    passwordConfirm: string;

    email = new ValidatorInput(
        'email',
        '',
        'E-Mail-Adresse',
        /^.$/,
        'Entschuldigung. Diese E-Mail akzeptieren wir nicht.',
        false,
        ValidationChecks.NOT_EMPTY_CHECK, this.checkEmail
    );

    emailConfirm: string;

    taskId: string;

    constructor() {
    }

    collection: ValidatorInput[] = [
        this.loginName,
        this.loginPIN,
        this.vorname,
        this.nachname,
        this.password,
        this.email,
    ];

    validateField(field: ValidatorInput) {
        field.valid = Validator.doValidate(field, 1, []);
    }

    validate(untilLabel = 'never stop(dummy)'): ValidationError[] {
        const result: ValidationError[] = [];

        for (const field of this.collection) {
            field.valid = Validator.doValidate(field, 1, result);

            if (field.name === untilLabel) {
                break;
            }
        }

        return result.length === 0 ? null : result;
    }

}
